import { enqueueSnackbar, UploadFile } from 'actions';
import { DownloadFile } from 'actions/sessionActions.js';

import {
	GetTrackerLastUpdateRequest,
	GetTrackerTableRequest,
	SyncTrackerRequest,
	DownloadTrackerRequest,
	ImportTrackerRequest
} from '../requests/TrackerRequests.js';

export const GET_TRACKER_LAST_UPDATE = 'GET_TRACKER_LAST_UPDATE';
export const GET_TRACKER_TABLE = 'GET_TRACKER_TABLE';
export const TOGGLE_IMPORT_MODAL_VISIBILITY = 'TOGGLE_IMPORT_MODAL_VISIBILITY';

const onGetTrackerLastUpdate = (value) => ({
	type: GET_TRACKER_LAST_UPDATE,
	trackerLastUpdate: value
});

export const GetTrackerLastUpdate = () => async (dispatch) => {
	await GetTrackerLastUpdateRequest().then(response => {
		dispatch(onGetTrackerLastUpdate(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

const onGetTrackerTable = (value) => ({
	type: GET_TRACKER_TABLE,
	trackerTableData: value
});

export const GetTrackerTable = () => async (dispatch) => {
	await GetTrackerTableRequest().then(response => {
		dispatch(onGetTrackerTable(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const SyncTracker = () => async (dispatch) => {
	await SyncTrackerRequest().then(response => {
		dispatch(GetTrackerTable());
		dispatch(GetTrackerLastUpdate());
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const DownloadTracker = () => async (dispatch) => {
	await DownloadTrackerRequest().then(response => {
		dispatch(DownloadFile(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

const onToggleImportModalVisibility = (visible) => ({
	type: TOGGLE_IMPORT_MODAL_VISIBILITY,
	importModalVisibility: visible
});

export const ToggleImportModalVisibility = (visible) => (dispatch) => {
	dispatch(onToggleImportModalVisibility(visible));
};

export const ImportTracker = (filePath) => async (dispatch) => {
	await ImportTrackerRequest(filePath).then(response => {
		dispatch(GetTrackerTable());
		dispatch(GetTrackerLastUpdate());
		dispatch(enqueueSnackbar({ message: 'Tracker successfully imported!', options: { variant: 'success' } }));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const UploadTracker = (file) => async (dispatch) => {
	await UploadFile(file).then(response => {
		dispatch(ImportTracker(response.data));
		dispatch(ToggleImportModalVisibility(false));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
